// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"025b9aea","567":"f3598e46","591":"c170040d","754":"32df5bac","795":"e237c322","902":"89712621","963":"21c85126"}[chunkId] + ".chunk.js";
};